export interface FileValidationResult {
  valid: boolean
  error?: string
}

export function validateExtension(file: File, extension: string[]): FileValidationResult {
  if (!extension.some((ext) => file.name.endsWith(`.${ext}`))) {
    return {
      valid: false,
      error: `Por favor, selecciona un archivo ${extension.join(', ').toUpperCase()} válido.`,
    }
  }
  return { valid: true }
}

export function validateSize(file: File, maxSize: number): FileValidationResult {
  if (file.size > maxSize) {
    return { valid: false, error: `El archivo no debe superar los ${maxSize / (1024 * 1024)}MB.` }
  }
  return { valid: true }
}

export function validateFile(file: File, maxSize: number, extension: string[]): void {
  const sizeResult = validateSize(file, maxSize)
  if (!sizeResult.valid) {
    throw new Error(sizeResult.error)
  }
  const extResult = validateExtension(file, extension)
  if (!extResult.valid) {
    throw new Error(extResult.error)
  }
}
